import React from 'react';

import './context-menu.css';
import { isEqual } from 'lodash';
import { GlobalContext } from '../../../../../../utils/globalprovider';

class ContextMenu extends React.Component {
  static contextType = GlobalContext;
  
  Item(word, suggest, index) {
    if (word.errorType === 'spelling') {
      return (
        <div
          className="list-item"
          role="listitem"
          key={index}
          tabIndex={0}
          onClick={() => this.props.onApplyCorrection(word, suggest)}
        >
          <p>{suggest}</p>
          <p className="message">{suggest.message}</p>
        </div>
      );
    }

    if (word.errorType === 'grammar') {
      return suggest.suggests.map((sug, sIndex) => {
        return (
          <div
            className="list-item"
            role="listitem"
            key={index + '-' + sIndex}
            tabIndex={0}
            onClick={() => this.props.onApplyCorrection(word, suggest, sug)}
          >
            <p>{sug}</p>
            <p className="message">{suggest.message}</p>
          </div>
        );
      });
    }

    if (word.errorType === 'spelling-en') {
      return suggest.suggests.map((sug, sIndex) => {
        return (
          <div
            className="list-item"
            role="listitem"
            key={index + '-en-' + sIndex}
            tabIndex={0}
            onClick={() => this.props.onApplyCorrection(word, suggest, sug)}
          >
            <p>{sug}</p>
          </div>
        );
      });
    }

    return <></>;
  }

  render() {
    if (!this.props.contextMenu.display) {
      return <></>;
    }

    const word = this.props.contextMenu.word;
    const suggests = word.suggests;

    if (!suggests || !suggests.length) {
      return <></>;
    }

    const lang = this.context.language;

    const sameSuggests =
      this.props.script.filter(
        (x) =>
          x.suggests &&
          x.suggests.length === 1 &&
          x.suggests[0].suggests &&
          x.suggests[0].suggests.length === 1 &&
          isEqual(x.suggests[0].suggests, suggests[0].suggests)
      ) || [];

    return (
      <div
        id="contextMenu"
        className="context-menu"
        style={{
          left: `${this.props.contextMenu.x}px`,
          top: `${this.props.contextMenu.y}px`,
        }}
      >
        <div role="list" className="list">
          {suggests.map((suggest, index) => {
            return this.Item(word, suggest, index);
          })}
        </div>
        <hr />
        <div role="list" className="list">
          <div
            className={'list-item' + (sameSuggests.length <= 1 ? ' hide' : '')}
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onApplyCorrectionAll(sameSuggests)}
          >
            {lang === 'fr'
              ? `Appliquer cette correction aux ${sameSuggests.length} occurences`
              : `Apply this correction to the ${sameSuggests.length} occurrences`}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onAddWordToDictionary(word)}
          >
             {lang === 'fr' ? 'Ajouter au dictionnaire' : 'Add to dictionary'}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onIgnoreWordForCorrection(word)}
          >
           {lang === 'fr' ? 'Ignorer ce mot' : 'Ignore this word'}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onIgnoreSuggestForCorrection(word)}
          >
            {lang === 'fr'
              ? 'Ignorer cette suggestion'
              : 'Ignore this suggestion'}
          </div>
        </div>
      </div>
    );
  }
}

export default ContextMenu;
